<template>
  <div>
    <button
      v-if="showGenerateButton"
      :disabled="linkButtonValid"
      class="btn btn-red claim-identifier ms-auto w-md-auto mt-2"
      @click="showModal"
    >
      {{ linkButtonName }}
    </button>
  </div>
</template>
<script>
import Swal from 'sweetalert2';
export default {
  data() {
    return {
      show: false,
      message: 'asdaasdasd',
      linkButtonName: 'Link Generálása',
    };
  },
  methods: {
    generateLink() {
      this.$store.commit('setGenerateLink', 1);
      console.log(this.$store.state.save_request_uid);
      this.$store.dispatch('getSavedDataByUid', this.$store.state.save_request_uid);
    },
    showModal() {
      //this.$store.commit('setSaveURL', '');
      this.$store.commit('setGenerateLink', 1);
      this.linkButtonName = 'Kérem várjon';
      this.$store.dispatch('verifyPage');
    },
  },
  computed: {
    linkButtonValid() {
      if (this.linkButtonName === 'Kérem várjon') return true;
      return !this.$store.state.canProceedToNextPage;
    },
    fetchURL() {
      return this.$store.state.fetch_url;
    },
    showGenerateButton() {
      let page = this.$store.state.page;
      let isDM = this.$store.state.dm;
      return isDM && page >= 4;
    },
  },
  watch: {
    fetchURL() {
      if (this.$store.state.fetch_url != null) {
        Swal.fire({
          input: 'text',
          inputValue: this.fetchURL,
          inputAttributes: {
            disabled: false,
          },
          text: 'Az alábbi linken keresztül érheti el a jelenlegi ',
          confirmButtonText: 'Másolás Vágólapra',
          confirmButtonColor: '#E4002C',
        }).then(() => {
          navigator.clipboard.writeText(this.fetchURL);
          Swal.fire('Link másolva a vágólapra');
        });
      }
      this.linkButtonName = 'Link Generálása';
    },
  },
};
</script>
